// import React, { useState, useRef } from 'react';
// import Form from 'react-bootstrap/Form';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Button from 'react-bootstrap/Button';
// import emailjs from 'emailjs-com';
// import ReCAPTCHA from "react-google-recaptcha";


// export const HAKraneForm = () => {
//   const [formData, setFormData] = useState({
//     first_name: '',
//     phone: '',
//     email_id: '',
//     company_name:'',
//     location: '',
//     date_delivery: '',
//     date_pickup: '',
//     message: '',
//   });

//   const [recaptchaValue, setRecaptchaValue] = useState(null);
//   const recaptchaRef = useRef(null);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const handleRecaptchaChange = (value) => {
//     setRecaptchaValue(value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!recaptchaValue) {
//       console.error('Please complete the reCAPTCHA.');
//       return;
//     }

//     // Your EmailJS configuration
//     const serviceId = 'service_sc3n7ma';
//     const templateId = 'template_4q243kc';
//     const userId = '2bmDb9D-p5ROkt5xX';

//     // Send the email using EmailJS
//     emailjs.send(serviceId, templateId, formData, userId)
//       .then((response) => {
//         console.log('Email sent successfully:', response);
//         // Reset the form after successful submission
//         setFormData({
//           first_name: '',
//           phone: '',
//           email_id: '',
//           company_name:'',
//           location:'',
//           date_delivery: '',
//           date_pickup: '',
//           message: '',
//         });
//         setRecaptchaValue(null);
//         recaptchaRef.current.reset();
//       })
//       .catch((error) => {
//         console.error('Error sending email:', error);
//       });
//   };

//   return (
//     <div className='contact' id="Contact">
//       <div className='Contact-container'>
//         <h1 className='GAKraneForm-title'>CONTACT FORM</h1>
//         <p className='GAKraneForm-subtitle'>
//           Don't hesitate to send us a message if you have any questions. We are here to help and would be delighted to assist you with any inquiries you may have.
//         </p>

        
//         <div className="contactUs" id="GAKrane-Form">
//           <div className='registerForm'>
//             <div className='formApply'>
//               <Form onSubmit={handleSubmit} className='GAKrane-Form'>
                
//                 <Form.Group className="mb-4" controlId="first_name">
//                   <Form.Label>Name:</Form.Label>
//                   <Form.Control
//                     required
//                     type="text"
//                     style={{ fontSize: '20px' }}
//                     // fontSize='20px'
//                     // placeholder="Name"
//                     name="first_name"
//                     value={formData.first_name}
//                     onChange={handleChange}
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4" controlId="phone">
//                   <Form.Label>Phone:</Form.Label>
//                   <Form.Control
//                     required
//                     type="tel"
//                     style={{ fontSize: '20px' }}
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     pattern="[0-9]*"
//                     required
//                     style={{ fontSize: '20px' }}
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4" controlId="email_id">
//                   <Form.Label>Email:</Form.Label>
//                   <InputGroup hasValidation>
//                     <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
//                     <Form.Control
//                       type="email"
//                       style={{ fontSize: '20px' }}
//                       // placeholder="Email"
//                       aria-describedby="inputGroupPrepend"
//                       required
//                       name="email_id"
//                       value={formData.email_id}
//                       onChange={handleChange}
//                     />
//                   </InputGroup>
//                 </Form.Group>

//                 <Form.Group className="mb-4" controlId="company_name">
//                   <Form.Label>Company:</Form.Label>
//                   <Form.Control
//                     required
//                     type="text"
//                     style={{ fontSize: '20px' }}
//                     required
//                     name="company_name"
//                     value={formData.company_name}
//                     onChange={handleChange}
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4" controlId="location">
//                   <Form.Label>Location Of Event:</Form.Label>
//                   <Form.Control
//                     required
//                     type="text"
//                     style={{ fontSize: '20px' }}
//                     required
//                     name="location"
//                     value={formData.location}
//                     onChange={handleChange}
//                     // placeholder="Enter the location of the event"
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-4" controlId="date_delivery">
//                   <Form.Label>Requested Date of Delivery:</Form.Label>
//                   <Form.Control
//                     required
//                     type="date"
//                     style={{ fontSize: '20px' }}
//                     required
//                     name="date_delivery"
//                     value={formData.date_delivery}
//                     onChange={handleChange}
//                   />
//                 </Form.Group>


//                 <Form.Group className="mb-4" controlId="date_pickup">
//                   <Form.Label>Requested Date of Pick Up:</Form.Label>
//                   <Form.Control
//                     required
//                     type="date"
//                     style={{ fontSize: '20px' }}
//                     required
//                     name="date_pickup"
//                     value={formData.date_pickup}
//                     onChange={handleChange}
//                   />
//                 </Form.Group>




//                 <Form.Group className="mb-4" controlId="message">
//                   <Form.Label>Message:</Form.Label>
//                   <InputGroup hasValidation>
//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       type="text"
//                       style={{ fontSize: '20px' }}
//                       name="message"
//                       required
//                       value={formData.message}
//                       onChange={handleChange}
//                     />
//                   </InputGroup>
//                 </Form.Group>

//                 <div className='d-flex justify-content-end'>
//                   <ReCAPTCHA sitekey='6Le8WicpAAAAALhfy0WdYOliGf5E_8eKFEEDffSy' onChange={handleRecaptchaChange} />
//                 </div>

//                 <div className='btnForm' style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                   <Button id="btnForm" type="submit">Send</Button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//         </div>
//         </div>
    
//   );
// };



// export default HAKraneForm;

import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

export const HAKraneForm = () => {

  const [formData, setFormData] = useState({
    first_name: '',
    phone: '',
    email_id: '',
    company_name: '',
    location: '',
    date_delivery: '',
    date_pickup: '',
    message: '',
  });

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const recaptchaRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted");

    if (!recaptchaValue) {
      console.error("Please complete reCAPTCHA");
      return;
    }

    const serviceId = 'service_sc3n7ma';
    const templateId = 'template_4q243kc';
    const userId = '2bmDb9D-p5ROkt5xX';

    emailjs
      .send(serviceId, templateId, formData, userId)
      .then((response) => {

        console.log("Email sent:", response);

        setFormData({
          first_name: '',
          phone: '',
          email_id: '',
          company_name: '',
          location: '',
          date_delivery: '',
          date_pickup: '',
          message: '',
        });

        setRecaptchaValue(null);
        recaptchaRef.current?.reset();

        setSuccessMessage("Thanks for getting in touch! We'll get back to you soon.");

        setTimeout(() => {
          setSuccessMessage('');
        }, 6000);

      })
      .catch((error) => {
        console.error("Email error:", error);
      });
  };

  return (
    <div className='contact' id="Contact">

      <div className='Contact-container'>

        <h1 className='GAKraneForm-title'>CONTACT FORM</h1>

        <p className='GAKraneForm-subtitle'>
          Don't hesitate to send us a message if you have any questions.
        </p>

        <div className="contactUs">

          <div className='registerForm'>
            <div className='formApply'>

              <Form onSubmit={handleSubmit} className='GAKrane-Form'>

                {/* NAME */}
                <Form.Group className="mb-4">
                  <Form.Label>Name:</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    style={{ fontSize: '20px' }}
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* PHONE */}
                <Form.Group className="mb-4">
                  <Form.Label>Phone:</Form.Label>
                  <Form.Control
                    required
                    type="tel"
                    style={{ fontSize: '20px' }}
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* EMAIL */}
                <Form.Group className="mb-4">
                  <Form.Label>Email:</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>@</InputGroup.Text>
                    <Form.Control
                      type="email"
                      required
                      style={{ fontSize: '20px' }}
                      name="email_id"
                      value={formData.email_id}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Form.Group>

                {/* COMPANY */}
                <Form.Group className="mb-4">
                  <Form.Label>Company:</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    style={{ fontSize: '20px' }}
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* LOCATION */}
                <Form.Group className="mb-4">
                  <Form.Label>Location:</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    style={{ fontSize: '20px' }}
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* DELIVERY */}
                <Form.Group className="mb-4">
                  <Form.Label>Delivery Date:</Form.Label>
                  <Form.Control
                    required
                    type="date"
                    style={{ fontSize: '20px' }}
                    name="date_delivery"
                    value={formData.date_delivery}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* PICKUP */}
                <Form.Group className="mb-4">
                  <Form.Label>Pick Up Date:</Form.Label>
                  <Form.Control
                    required
                    type="date"
                    style={{ fontSize: '20px' }}
                    name="date_pickup"
                    value={formData.date_pickup}
                    onChange={handleChange}
                  />
                </Form.Group>

                {/* MESSAGE */}
                <Form.Group className="mb-4">
                  <Form.Label>Message:</Form.Label>
                  <InputGroup>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      style={{ fontSize: '20px' }}
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Form.Group>

                {/* CAPTCHA */}
                <div className='d-flex justify-content-end mb-3'>
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA'
                    sitekey='6Le8WicpAAAAALhfy0WdYOliGf5E_8eKFEEDffSy'
                    onChange={handleRecaptchaChange}
                  />
                </div>

                {/* ✅ SUCCESS MESSAGE (ARRIBA DEL BOTÓN) */}
                {successMessage && (
                  <div className="alert alert-success text-center mb-3">
                    {successMessage}
                  </div>
                )}

                {/* BUTTON */}
                <div className='btnForm' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button type="submit" id="btnForm">
                    Send
                  </Button>
                </div>

              </Form>

            </div>
          </div>

        </div>

      </div>

    </div>
  );
};

export default HAKraneForm;